import { MrSearchConfig } from '@net7/boilerplate-muruca';

const facets = {
  sections: [
    {
      id: 'section-query',
      inputs: [
        {
          id: 'query',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query',
            placeholder: 'search#placeholder_query',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    {
      id: 'section-languages',
      header: {
        id: 'header-languages',
        data: {
          text: 'search#header_languages',
          additionalText: null
        }
      },
      inputs: [{
        id: 'languages',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    },
    {
      id: 'section-subjects',
      header: {
        id: 'header-subjects',
        data: {
          text: 'search#header_subjects',
          additionalText: null
        }
      },
      inputs: [{
        id: 'subjects',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    },
    {
      id: 'section-romances',
      header: {
        id: 'header-romances',
        data: {
          text: 'search#header_romances',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'romances',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    },
    {
      id: 'section-authors',
      header: {
        id: 'header-authors',
        data: {
          text: 'search#header_authors',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'authors',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    },
    {
      id: 'section-traduttore',
      header: {
        id: 'header-translators',
        data: {
          text: 'search#header_translators',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'traduttore',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    },
  ],
  classes: 'facets-wrapper',
};

const layoutInputs = ['page', 'limit', 'sort'].map((id) => ({
  id,
  queryParam: true,
  schema: {
    valueType: id === 'sort' ? 'string' : 'number',
  },
}));

const request = {
  results: {
    id: 'search',
    delay: 500,
  },
  facets: {
    id: 'facets',
  },
  provider: 'rest',
  delay: 500,
};

export default { request, facets, layoutInputs } as MrSearchConfig;
